<template>
  <div class="mainList">
    <el-table :data="tabData" style="width: 100%" class="myTable" min-height="500">
      <el-table-column label="租户" prop="tenantName" />
      <el-table-column prop="date" label="日期" width="150"> </el-table-column>
      <el-table-column prop="registerCount" label="注册人数" />
      <el-table-column prop="firstDepositNum" label="首冲人数" />
      <el-table-column prop="tradeUserCount" label="开仓人数" />
      <el-table-column prop="positionUidCount" label="平仓人数" />
      <el-table-column prop="positionCount" label="平仓数量" />
      <el-table-column prop="depositAmount" label="充值" width="160" />
      <el-table-column prop="withdrawAmount" label="提现" width="160" />
      <el-table-column prop="withdrawFee" label="提现手续费" width="160" />
      <el-table-column prop="cast" label="资金费用" width="160" />
      <el-table-column prop="otcDepositAmount" label="法币买入" width="160" />
      <el-table-column prop="otcWithdrawAmount" label="法币卖出" width="160" />
      <el-table-column prop="totalDeposit" label="净入金" width="160" />
      <el-table-column prop="userBalance" label="用户余额" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openDialog(scope.row)">{{
            scope.row.userBalance
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="walletBalance" label="钱包余额" width="160" />
      <el-table-column prop="otcWalletBalance" label="otc钱包余额" width="160" />

      <el-table-column prop="totalFee" label="总手续费" width="160" />
      <el-table-column prop="positionProfit" label="平仓盈亏" width="160" />
      <el-table-column prop="feeDay" label="手续费日返" width="160" />
      <el-table-column prop="feeDayGrant" label="手续费日返-已发放" width="160" />
      <el-table-column prop="profitWeek" label="盈亏周返" width="160" />
      <el-table-column prop="netProfit" label="净利润" width="160" />
      <el-table-column prop="internalTransferInAmount" label="内部转入" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openInternalRecordsDialog('in', scope.row)">{{
            scope.row.internalTransferInAmount
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="internalTransferOutAmount" label="内部转出" width="160">
        <template slot-scope="scope">
          <span class="userBalance" @click="openInternalRecordsDialog('out', scope.row)">{{
            scope.row.internalTransferOutAmount
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="totalProfit" label="总盈亏" />
      <el-table-column prop="ptprofit" label="平台盈亏" />
      <el-table-column prop="personalProfit" label="散户净盈亏" />
      <el-table-column prop="groupProfit" label="团队净盈亏" />
      <el-table-column prop="realProfit" label="平台实际盈亏" /> -->
    </el-table>
    <pagination :size="paginations.size" :page="paginations.page" :total="totalCount" @pageChanged="handlePageChanged">
    </pagination>

    <el-dialog :visible="detailDialogVisible" title="余额明细" @close="closeDialog" width="70%">
      <el-input placeholder="用户ID" v-model="userId" clearable class="userIdInput"></el-input>
      <el-button size="small" @click="handleSearch" type="primary">搜索</el-button>
      <el-table :data="dialogList" style="width: 100%" class="myTable" max-height="400px">
        <!-- <el-table-column prop="date" label="日期" width="150">
        </el-table-column> -->
        <el-table-column prop="userId" label="用户UID" />
        <el-table-column prop="tigerBalance" label="合约总资产" />
        <el-table-column prop="otcBalance" label="法币总资产" />
        <el-table-column prop="realizedProfit" label="平仓盈亏" />
        <el-table-column prop="fee" label="手续费" />
        <el-table-column prop="profitTotal" label="盈利" />
        <el-table-column prop="profit" label="合约未实现盈亏" />
        <el-table-column prop="tigerRealizedProfit" label="合约已实现盈亏" />
      </el-table>
      <pagination :size="paginationsDialog.size" :page="paginationsDialog.page" :total="totalCountDialog"
        @pageChanged="handlePageChangedDialog">
      </pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible="internalRecordsVisible"
      :title="internalRecordsTitle"
      @close="closeInternalRecordsDialog"
      width="72%"
    >
      <el-table v-loading="internalRecordsLoading" :data="internalPagedList" class="myTable" max-height="420px">
        <el-table-column prop="userId" label="用户ID" width="100" />
        <el-table-column label="创建时间" width="170">
          <template slot-scope="scope">{{ scope.row.createdTime | moment }}</template>
        </el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.txType === -2 && scope.row.remark === 'internal'">内部转入</span>
            <span v-else-if="scope.row.txType === -2">内部转出</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="txAmount" label="数量" width="100" />
        <el-table-column prop="txCoin" label="币种" width="80" />
        <el-table-column prop="chain" label="币种链" width="90" />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="internalStatusMeta(scope.row.txStatus)" :type="internalTagType(scope.row.txStatus)">{{
              internalStatusMeta(scope.row.txStatus).text
            }}</el-tag>
            <span v-else>{{ scope.row.txStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      </el-table>
      <pagination
        :size="internalPagination.size"
        :page="internalPagination.page"
        :total="internalAllRows.length"
        @pageChanged="handleInternalPageChanged"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeInternalRecordsDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "../../api";
import { STATUS_TYPE } from "../../../Audit/Withdrawal/constants";

const WITHDRAW_TX_STATUSES = ["0", "1", "2", "4", "5", "6", "7", "-1"];

export default {
  props: ["totalCount", "tabData", "topChannelUserId"],
  data() {
    return {
      paginations: {
        page: 1,
        size: 10,
      },
      detailDialogVisible: false,
      userId: "",
      paginationsDialog: {
        page: 1,
        size: 10,
      },
      totalCountDialog: 0,
      cacheRow: {},
      dialogList: [],
      internalRecordsVisible: false,
      internalRecordsLoading: false,
      internalDirection: "in",
      internalCacheRow: {},
      internalAllRows: [],
      internalPagination: { page: 1, size: 10 },
    };
  },
  components: { Pagination },
  computed: {
    internalRecordsTitle() {
      return this.internalDirection === "in" ? "内部转入记录" : "内部转出记录";
    },
    internalPagedList() {
      const { page, size } = this.internalPagination;
      const start = (page - 1) * size;
      return this.internalAllRows.slice(start, start + size);
    },
  },
  watch: {
    topChannelUserId: {
      handler(val) {
        this.userId = val;
      },
      immediate: true,
    },
  },
  mounted() {
    this.userId = this.topChannelUserId;
  },
  methods: {
    handlePageChanged(pagination, flag) {
      this.paginations = pagination;
      !flag && this.$emit("refreshTab", this.paginations);
    },
    handlePageChangedDialog(pagination) {
      this.paginationsDialog = pagination;
      this.getList();
    },
    openDialog(row) {
      this.detailDialogVisible = true;
      this.cacheRow = row;
      this.getList();
    },
    closeDialog() {
      this.detailDialogVisible = false;
      this.cacheRow = false;
      this.paginationsDialog = { page: 1, size: 10 };
    },

    getList() {
      api
        .userTradeInfo({
          userId: this.userId,
          time: this.cacheRow.date,
          ...this.paginationsDialog,
        })
        .then((res) => {
          if (res.code == 0) {
            this.dialogList = res.data.list;
            this.totalCountDialog = res.data.totalCount;
          }
        });
    },
    handleSearch() {
      this.getList();
    },

    /** 与交易统计日期口径一致：UTC 自然日 00:00:00～23:59:59（date 为 yyyy-MM-dd） */
    internalDayRangeUtc(dateStr) {
      const start = new Date(`${dateStr}T00:00:00.000Z`).getTime();
      const end = new Date(`${dateStr}T23:59:59.999Z`).getTime();
      return { startTime: start, endTime: end };
    },

    openInternalRecordsDialog(direction, row) {
      this.internalDirection = direction;
      this.internalCacheRow = row;
      this.internalPagination = { page: 1, size: 10 };
      this.internalRecordsVisible = true;
      this.loadInternalRecords();
    },

    closeInternalRecordsDialog() {
      this.internalRecordsVisible = false;
      this.internalAllRows = [];
      this.internalPagination = { page: 1, size: 10 };
      this.internalCacheRow = {};
    },

    handleInternalPageChanged(pagination) {
      this.internalPagination = pagination;
    },

    internalStatusMeta(txStatus) {
      const meta = STATUS_TYPE[txStatus];
      return meta || STATUS_TYPE[String(txStatus)];
    },

    internalTagType(txStatus) {
      const meta = this.internalStatusMeta(txStatus);
      if (!meta || !meta.color) return "info";
      if (meta.color === "disabled") return "info";
      return meta.color;
    },

    /**
     * 与「审批-提现审批」列表一致：txType=-2 且 remark==='internal' 为内部转入，否则为内部转出。
     * 接口按 txStatus 分栏，这里并行拉取各状态后合并去重，再按方向过滤并前端分页。
     */
    loadInternalRecords() {
      const dateStr = this.internalCacheRow && this.internalCacheRow.date;
      if (!dateStr) {
        this.internalAllRows = [];
        return;
      }
      const { startTime, endTime } = this.internalDayRangeUtc(dateStr);
      const base = {
        txType: -2,
        startTime,
        endTime,
        page: 1,
        size: 500,
      };
      if (this.topChannelUserId) {
        base.channelUserId = this.topChannelUserId;
      }
      this.internalRecordsLoading = true;
      Promise.all(
        WITHDRAW_TX_STATUSES.map((txStatus) =>
          api.searchWithdrawAuditRecords({ ...base, txStatus }).catch(() => ({ data: { list: [] } }))
        )
      )
        .then((responses) => {
          const byId = new Map();
          responses.forEach((res) => {
            const list = (res && res.data && res.data.list) || [];
            list.forEach((row) => {
              if (row && row.id != null && !byId.has(row.id)) {
                byId.set(row.id, row);
              }
            });
          });
          let merged = Array.from(byId.values());
          merged = merged.filter((r) => r.txType === -2);
          if (this.internalDirection === "in") {
            merged = merged.filter((r) => r.remark === "internal");
          } else {
            merged = merged.filter((r) => r.remark !== "internal");
          }
          merged.sort((a, b) => (b.createdTime || 0) - (a.createdTime || 0));
          this.internalAllRows = merged;
          this.internalPagination = { ...this.internalPagination, page: 1 };
        })
        .finally(() => {
          this.internalRecordsLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.el-table__header {
  width: 100% !important;

  th.el-table__cell.is-leaf {
    background: #ccc;
  }
}

.el-table__body {
  width: 100% !important;
}

.userBalance {
  color: #409eff;
  cursor: pointer;
}

.userIdInput {
  width: 300px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
